import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/useAuth';

export const Protected = ({ redirectPath = '/', children }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};
